import { useTranslation } from 'react-i18next';
import { CreditCardIcon } from '@heroicons/react/24/outline';
import type { StripePaymentMethodInfo } from '@/types/stripe';

function capitalizeBrand(brand: string | null | undefined, fallback: string): string {
  if (!brand) return fallback;
  return brand.charAt(0).toUpperCase() + brand.slice(1).toLowerCase();
}

interface StripeDefaultPaymentMethodCardProps {
  paymentMethod: StripePaymentMethodInfo | null | undefined;
}

export function StripeDefaultPaymentMethodCard({ paymentMethod }: StripeDefaultPaymentMethodCardProps) {
  const { t } = useTranslation('billing');

  if (!paymentMethod) {
    return <div className="text-sm text-gray-600">{t('paymentMethodCard.noData')}</div>;
  }

  const brand = capitalizeBrand(paymentMethod.brand, t('paymentMethodCard.defaultBrand'));
  const last4 = paymentMethod.last4 || '····';
  const exp = paymentMethod.exp_month && paymentMethod.exp_year
    ? `${String(paymentMethod.exp_month).padStart(2, '0')}/${paymentMethod.exp_year}`
    : null;

  return (
    <div className="flex items-center gap-3 p-3 rounded-lg border border-gray-200 bg-gray-50/50">
      <CreditCardIcon className="w-8 h-8 text-gray-400 flex-shrink-0" aria-hidden />
      <div className="text-sm text-gray-700">
        <span className="font-medium">{brand}</span>
        <span className="text-gray-600"> •••• {last4}</span>
        {exp && <span className="text-gray-500 text-xs block mt-0.5">{t('paymentMethodCard.exp', { date: exp })}</span>}
      </div>
    </div>
  );
}

